<template>
  <v-card class="ma-2">
    <v-row class="mt-3">
      <v-card-title class="primary--text"
        >Budget Duration
        <v-divider vertical class="ml-5 mx-0"></v-divider>
      </v-card-title>
      <v-card-actions />
    </v-row>
    <v-row class="ml-3">
      <v-col md="2">
        <v-chip class="mt-1" color="secondary" label text-color="white">
          ABC Corp
        </v-chip>
      </v-col>
      <v-col md="3">
        <v-select
          label="Duration"
          v-model="duration"
          outlined
          dense
          :items="durations"
        ></v-select>
      </v-col>
      <v-col><v-btn class="primary white--text">Set</v-btn></v-col>
    </v-row>

    <v-data-table
      :headers="budgetdata"
      dense
      :items="budgetitems"
    ></v-data-table>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    durations: ["Daily", "Weekly", "Monthly"],
    budgetdata: [
      {
        text: "Duration set",
        value: "duration",
      },
      {
        text: "Last updated date",
        value: "date",
      },
    ],
    budgetitems: [
      {
        duration: "Monthly",
        date: "30-03-2021",
      },
      {
        duration: "Weekly",
        date: "23-03-2021",
      },
    ],
  }),
};
</script>

<style>
</style>